import React, { Component } from "react"
import { Table, Row, Icon } from "antd"
import { observer, inject } from "mobx-react"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import FlexableFileName from "app/components/normal/FlexableFileName"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import { PREPARE_RUN, RUNNING } from 'app/utils/const'

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
      showDeleteModal: false,
      dataSingle: {},
      editedHistory: []
    }

    this.columns = []
  }

  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  render() {
    const {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      },
    } = this.props

    const renderContent = (text, record, index) => {
      const obj = {
        children: text,
        props: {},
      }
      if (record.state === PREPARE_RUN || record.state === RUNNING) {
        obj.props.colSpan = 0
      }
      return obj
    }

    const columns = [
      {
        title: "文件名称",
        dataIndex: "filename",
        width: "24.1%",
        sorter: (a, b) => a.filename.localeCompare(b.filename),
        render: (text, record, index) => {
          const { list: { queryMap: { keywords } } } = this.props.store
          return (
            <FlexableFileName filename={text} keywords={keywords} isEqual={true} />
          )
        }
      }, {
        width: "12.71%",
        title: "样本名称",
        dataIndex: "sampleName",
        sorter: (a, b) => a.sampleName.localeCompare(b.sampleName),
        render: (text) => {
          const { list: { queryMap: { keywords } } } = this.props.store

          return (
            <MaterialTip title={text}>
              <div className="sample-name ellipsis">
                <Highlighter
                  highlightStyle={{ fontWeight: "normal" }}
                  searchWords={highlightable(text, keywords) ? [text] : []}
                  textToHighlight={text}
                />
              </div>
            </MaterialTip>
          )
        }
      }, {
        title: (<div className="ta-r">Total_Reads</div>),
        className: "ta-r",
        dataIndex: "totalReads",
        render: (text, record, index) => {
          const stateData = [
            {
              text: "数据准备运行",
              className: "pre-run pgs-state-element"
            },
            {
              text: "数据正在运行",
              className: "running pgs-state-element"
            },
          ]
          switch (record.state) {
            case 0:
              return {
                children: (
                  <Row type="flex" justify="center" align="middle">
                    <div className={stateData[0].className}>
                      <Icon type="hourglass" />
                      {stateData[0].text}
                    </div>
                  </Row>
                ),
                props: {
                  colSpan: 6
                }
              }
            case 1:
              return {
                children: (
                  <Row type="flex" justify="center" align="middle">
                    <div className={stateData[1].className}>
                      <Icon type="clock-circle-o" />
                      {stateData[1].text}
                    </div>
                  </Row>
                ),
                props: {
                  colSpan: 6
                }
              }
            default:
              return (<div>{text}</div>)
          }
        }
      }, {
        title: (<div className="ta-r">MT_ratio(%)</div>),
        className: "ta-r",
        dataIndex: "mtRatio",
        render: renderContent
      }, {
        title: (<div className="ta-r">Map_Ratio(%)</div>),
        className: "ta-r",
        dataIndex: "mapRatio",
        render: renderContent
      }, {
        title: (<div className="ta-r">Duplicate(%)</div>),
        className: "ta-r",
        dataIndex: "duplicate",
        render: renderContent
      }, {
        title: (<div className="ta-r">GC_Count(%)</div>),
        className: "ta-r",
        dataIndex: "gcCount",
        render: renderContent
      }, {
        title: (<div className="ta-r">*SD</div>),
        className: "ta-r",
        dataIndex: "sd",
        render: renderContent
      }, {
        title: (<div className="ta-r">基线</div>),
        className: "ta-r",
        dataIndex: "baselineName",
        render: renderContent
      }
    ]

    return (
      <div className="wrapper-box">
        <Table
          columns={columns}
          className="statistics-table"
          rowKey={record => record.reportId}
          dataSource={tableData.slice()}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/research/pgs/statistics/containers/DataTable.js